/* src/pages/admin/AdminPodcastForm.js (Updated with Media Library) */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminMediaLibrary from './AdminMediaLibrary';

const AdminPodcastForm = ({ podcastId, onSave, onCancel }) => {
    const [formData, setFormData] = useState({ title: '', author_name: '', category: '', tags: '', audio_url: '', thumbnail_url: '' });
    const [isMediaLibraryOpen, setIsMediaLibraryOpen] = useState(false);
    const [selectingFor, setSelectingFor] = useState(null);
    const [s3Prefix, setS3Prefix] = useState('');

    useEffect(() => {
        if (podcastId) {
            const token = localStorage.getItem('app_token');
            axios.get(`/api/admin/podcasts/${podcastId}`, { headers: { Authorization: `Bearer ${token}` } })
                .then(res => setFormData({ ...res.data, tags: res.data.tags || ''}));
        }
    }, [podcastId]);

    const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const openMediaLibrary = (field, prefix) => {
        setSelectingFor(field);
        setS3Prefix(prefix);
        setIsMediaLibraryOpen(true);
    };

    const handleMediaSelect = (url) => {
        setFormData({ ...formData, [selectingFor]: url });
        setIsMediaLibraryOpen(false);
    };

    const handleSubmit = e => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <>
            {isMediaLibraryOpen && (
                <AdminMediaLibrary
                    s3Prefix={s3Prefix}
                    onSelect={handleMediaSelect}
                    onCancel={() => setIsMediaLibraryOpen(false)}
                />
            )}
            <div className="admin-modal-overlay">
                <div className="admin-modal-content">
                    <h2>{podcastId ? 'Edit Podcast' : 'Add New Podcast'}</h2>
                    <form onSubmit={handleSubmit} className="admin-form">
                        <div className="form-group">
                            <label htmlFor="title">Title</label>
                            <input type="text" name="title" value={formData.title} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="author_name">Author</label>
                            <input type="text" name="author_name" value={formData.author_name} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="category">Category</label>
                            <input type="text" name="category" value={formData.category} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">Tags (comma-separated)</label>
                            <input type="text" name="tags" value={formData.tags} onChange={handleChange} />
                        </div>

                        <div className="form-group">
                            <label>Audio File</label>
                            <div className="media-input-group">
                                <input type="text" name="audio_url" value={formData.audio_url} readOnly placeholder="Select an audio file..." />
                                <button type="button" className="btn-secondary" onClick={() => openMediaLibrary('audio_url', 'hj1/public/assets/audio/')}>Select</button>
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Thumbnail Image</label>
                             <div className="media-input-group">
                                <input type="text" name="thumbnail_url" value={formData.thumbnail_url} readOnly placeholder="Select an image..." />
                                <button type="button" className="btn-secondary" onClick={() => openMediaLibrary('thumbnail_url', 'hj1/public/assets/thumbnails/')}>Select</button>
                            </div>
                        </div>

                        <div className="form-actions">
                            <button type="button" onClick={onCancel} className="btn-secondary">Cancel</button>
                            <button type="submit" className="btn-primary">Save Podcast</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default AdminPodcastForm;
